// todo создать место для общих хуков и вынести
import { useEffect, useState } from 'react';

// расширять при необходимости
type WebApi = {
  document?: Document;
  window?: Window;
};

export default (): WebApi => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (isMounted) {
    return {
      window,
      document: window.document,
    };
  }

  return {};
};
